import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting, useAppState } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import SubmitButton from "./elements/SubmitButton"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const {
        loading, query
    } = useAppState()
    const { format } = useCurrencyFormatting()

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    let matchingCategoriesSet = new Set();

    products?.hits?.forEach(product => {
        product.categories.forEach(category => {
            if (category.toLowerCase().includes(query.query.toLowerCase())) {
                matchingCategoriesSet.add(category);
            }
        });
    });

    let matchingCategories = Array.from(matchingCategoriesSet);

    return (
        <div
            class="ns-autocomplete ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
        >

            <div class="ns-autocomplete-arrow" style="top: -20px;left: 111px;"></div>
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            <div class="ns-autocomplete-products-wrapper">
                                <div class="ns-sf-search-suggestion-header-product ns-sf-search-suggestion-header">
                                    Products
                                </div>
                                {products?.hits?.map(hit => {
                                    return (
                                        <AutocompleteElement hit={hit}>
                                            <div
                                                data-url={hit.url}
                                                class="ns-autoc-prod ns-d-flex flex-row ns-clickable"
                                                data-nosto-element="product"
                                            >
                                                <a href="javascript:void(0)" class="ns-sf-search-suggestion-left">
                                                    <img
                                                        class="ns-h-auto ns-object-contain"
                                                        src={hit.imageUrl ?? productImagePlaceholder}
                                                        alt={hit.name}
                                                    />
                                                </a>
                                                <div class="ns-sf-search-suggestion-right">
                                                    <div class="ns-sf-search-suggestion-product-title ns-clipped ns-text-one-line">
                                                        {hit.name}
                                                    </div>
                                                    <div class="ns-sf-search-suggestion-product-price">
                                                     <span class="bc-sf-product-regular-price">{format(hit.price)}</span>
                                                        {hit.listPrice && hit.listPrice > hit.price && (
                                                            <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2" style="
                                                            opacity: 0.5;
                                                        ">
                                                                {format(hit.listPrice)}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </AutocompleteElement>
                                    )
                                })}
                            </div>
                            
                        </div>
                    )}

                    {keywords?.hits?.length > 0 && (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column`}
                        >
                            <div class="ns-sf-search-suggestion-header-keywords ns-sf-search-suggestion-header">
                                Suggestions
                            </div>
                            <div class="ns-autocomplete-results ns-clickable">
                                {keywords?.hits?.map((hit) => (
                                    <AutocompleteElement class="ns-clickable ns-w-100" hit={hit} key={hit.keyword}>
                                        <div class="ns-autoc-result ns-w-100">
                                        {hit._highlight.keyword ? (
                                            <span class="ns-autoc-select" dangerouslySetInnerHTML={{ __html: hit._highlight.keyword }}></span>
                                        ) : (
                                            <span>{hit.keyword}</span>
                                        )}
                                        </div>
                                    </AutocompleteElement>
                                ))}
                            </div>
                        </div>
                    )}
                         {/* <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column`}
                        >
                            <div class="ns-sf-search-suggestion-header-keywords ns-sf-search-suggestion-header">
                                Collections
                            </div>
                            <div class="ns-autocomplete-results ns-clickable">
                                {matchingCategories?.length > 0 && (
                                    matchingCategories?.map(category => {
                                    const categoryUrlPath = category.toLowerCase().replace(/\s+/g, '-').replace(',', '').replace("'", "");
                                    return (
                                    <div class="ns-clickable ns-w-100">
                                        <div class="ns-autoc-result ns-w-100">
                                        
                                            
                                                
                                                    <>
                                                        <a href={`/collections/${categoryUrlPath}`} class="v-stack gap-3 sm:gap-5">
                                                            <span class="h6 sm:h5">{category}</span>
                                                        </a>
                                                    </>
                                               
                                        
                                        </div>
                                    </div>
                                     )
                                    })
                                )}
                            </div> 
                        </div> */}
                    <SubmitButton text={`View all ${products?.total} products`} />

                    
        </div>
    )
}
